'use client'

import { Icon } from '@phosphor-icons/react'
import { VariantProps, cva } from 'class-variance-authority'
import { ReactElement, cloneElement } from 'react'
import { cn } from '@/core/lib/utils'

const checkboxLabelStyle = cva('inline-flex items-center rounded-sm', {
  variants: {
    size: {
      normal: 'px-2 py-1 text-xs font-bold',
      small: 'px-2 py-0.5 text-xs',
    },
    color: {
      purple: 'bg-purple-600 text-white',
      'purple-light': 'bg-purple-100 text-purple-800',
      yellow: 'bg-yellow-500 text-yellow-950',
      'yellow-light': 'bg-yellow-100 text-yellow-800',
      red: 'bg-red-600 text-white',
      'red-light': 'bg-red-100 text-red-900',
      green: 'bg-green-600 text-white',
      'green-light': 'bg-green-100 text-green-900',
      pink: 'bg-pink-600 text-white',
      'pink-light': 'bg-pink-100 text-pink-900',
      gray: 'bg-gray-500 text-white',
      'gray-light': 'bg-gray-200 text-gray-900',
      blue: 'bg-blue-150 text-blue-900',
      'blue-light': 'bg-blue-100 text-blue-800',
      'blue-dark': 'bg-blue-600 text-white',
    },
  },
  defaultVariants: {
    size: 'normal',
    color: 'purple',
  },
})

const Tag = ({
  className,
  size,
  color,
  text,
  icon,
  iconPosition = 'left',
  ...props
}: VariantProps<typeof checkboxLabelStyle> & {
  className?: string
  text: string
  icon?: ReactElement<Icon>
  iconPosition?: 'left' | 'right'
}) => (
  <span
    className={cn(checkboxLabelStyle({ size, color }), className)}
    {...props}
  >
    {icon &&
      iconPosition === 'left' &&
      cloneElement(icon, {
        // TODO: Proper typing
        //@ts-ignore
        size: 16,
        className: 'mr-1',
      })}
    <span className="whitespace-nowrap">{text}</span>
    {icon &&
      iconPosition === 'right' &&
      cloneElement(icon, {
        // TODO: Proper typing
        //@ts-ignore
        size: 16,
        className: 'ml-1',
      })}
  </span>
)

export { Tag }
